import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumbs from "../layout/Breadcrumbs";

import Contact from "../pages/contact/Contact";
import HappyClients from "../pages/happyclients/HappyClients";

import AOS from "aos";
import "aos/dist/aos.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Navigation, Autoplay } from "swiper/modules";

// Dummy Project Data (Replace with API data in real use)
const portfolioItems = [
{
    id: 1,
    category: "club-portal",
    image: "/assets/images/success-stories/product-1.jpg",
    link: "/project-details/1",
    title: "Club Portal",
    description: "Customizable Teamwear Management",
    details: [
      "B2B Sport Portal delivers high performance, customizable teamwear solutions for clubs and athletes across Australia and New Zealand. Leveraging Italian design heritage, they provide modern, durable sports apparel made from top-quality fabrics. Teams can create personalized kits featuring unique colors, logos, and sponsor details, combining style and functionality to meet the demands of todays athletes.",
      "All across Australia, from local clubs to professional athletes, individuals unite in their passion for sports through the B2B Sport Portal. With our dynamic styles and technical designs crafted from high quality fabrics, players of all levels stay at the peak of their game, ready to challenge themselves and forge unforgettable moments together.",
    ],
    technologies: {
      frontend: [
        "Angular 18",
        "HTML",
        "CSS",
        "Visual Studio Code"
      ],
      backend: [
        ".NET 6 Core",
        "SQL Server",
        "Entity Framework Core",
        "Visual Studio",
        "Postman",
        "Swagger"
      ]
    },    
    thirdPartyTools: [
      "PayPal Payment Gateway",
      "Bitbucket",
      "GitHub",
      "JWT Token Authentication",
    ],
    images: [
      "/assets/images/success-stories/club-portal/kappa_project_01.jpg",
      "/assets/images/success-stories/club-portal/kappa_project_02.jpg",
      "/assets/images/success-stories/club-portal/kappa_project_03.jpg",
      "/assets/images/success-stories/club-portal/kappa_project_01.jpg",
      "/assets/images/success-stories/club-portal/kappa_project_02.jpg",
      "/assets/images/success-stories/club-portal/kappa_project_03.jpg",
    ],
    credentials: [
      {
        link: "https://kappastageapp.kappaclubportal.com.au/#/",
        username: "",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "/assets/pdf/B2BSportsPortal.pdf" },
      {
        name: "Customizable teamwear for clubs",
        url: "/assets/pdf/B2BSportsPortal.pdf",
      },
    ],
    video: "/assets/videos/project-details/B2BSportsPortal.mp4", // Can be a YouTube link as well
  },

  {
    id: 2,
    category: "cms",
    image: "/assets/images/success-stories/product-1.jpg",
    link: "/project-details/2",
    title: "DBS",
    description: "Dealer Management System",
    details: [
      "A robust solution for dealers to streamline and automate their business processes.Facilitating Vehicle Sales for Dealers in Canada and the US.",
      "Agenda Of Dealer Management System:",
      [
        "1. Data Center",
        "2. AITHR Market Place",
        "3. Manage Lender",
        "4. E - Block",
        "5. Admin",
        "6. Logs",
        "7. Credit App - Beta",
        "8. Manage Inventory"
      ]
    ],
    technologies: {
      frontend: [
        "Angular 18",
        "HTML",
        "CSS",
        "Visual Studio Code"
      ],
      backend: [
        ".NET 6 Core",
        "SQL Server",
        "Entity Framework Core",
        "Swagger"
      ]
    },    
    thirdPartyTools: [
      "PayPal Payment Gateway",
      "GitHub",
      "JWT Token Authentication",
    ],
    images: [
      "/assets/images/success-stories/dealer-bussiness/dbs_project_01.jpg",
      "/assets/images/success-stories/dealer-bussiness/dbs_project_02.jpg",
      "/assets/images/success-stories/dealer-bussiness/dbs_project_03.jpg",
      "/assets/images/success-stories/dealer-bussiness/dbs_project_04.jpg",
      "/assets/images/success-stories/dealer-bussiness/dbs_project_05.jpg",
      "/assets/images/success-stories/dealer-bussiness/dbs_project_02.jpg",
    ],
    credentials: [
      {
        link: "https://dealerx.myskillwork.com/#/",
        username: "",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "/assets/pdf/Dealer_Management_System.pdf" },
      {
        name: "Dealer Bussiness Software",
        url: "/assets/pdf/Dealer_Management_System.pdf",
      },
    ],
    video: "/assets/videos/project-details/Dealer_Management_System.mp4", // Can be a YouTube link as well
  },

  {
    id: 3,
    category: "design",
    image: "/assets/images/success-stories/product-3.jpg",
    link: "/project-details/3",
    title: "Aplus Autism",
    description: "Learning Management System (LMS)",
    details: [
      "A+ Autism Applications is a groundbreaking tool designed to enhance the lives of individuals with autism and revolutionize their interaction with the world. By clicking Get Started, users access our homepage at https://www.aplusautism.com, featuring thousands of high-definition images across all life categories, offering a diverse and enriching visual experience.",
      "Explore nature's intricacies or navigate urban landscapes with each image, transforming user journeys into serene voyages of discovery with calming music that promotes relaxation and focus.A+ Autism Applications excels in communication with exceptional multilingual support, offering content in eight languages, pronounced by native speakers to bridge language barriers.",
      "The app enhances sensory experiences by incorporating realistic object sounds, immersing users in a comprehensive auditory environment.",
      "A+ Autism Applications is a multisensory platform inviting users to engage, explore, and enjoy the journey of learning and communication. Dive into A+ Autism Applications for an enriched, inclusive world.",
      "Affordability is key, with a pricing model ensuring quality education and communication are accessible. A preview feature lets users review lessons before purchasing, aligning with their learning objectives and interests.Experience the A+ difference today!"
    ],
    technologies: {
      frontend: ["Figma", "Bootstrap", "HTML/CSS", "Blazor", "cshtml", "JavaScript", "Jquery",],
      backend: ["SQL Server", "C#", "MVC", "Swagger"],
    },
    thirdPartyTools: ["Visual Studio" , "PayPal Payment Gateway", "GitHub", "JWT Token Authentication"],
    images: [
      "/assets/images/success-stories/aplusautism/learning_management_project_01.jpg",
      "/assets/images/success-stories/aplusautism/learning_management_project_02.jpg",
      "/assets/images/success-stories/aplusautism/learning_management_project_03.jpg",
      "/assets/images/success-stories/aplusautism/learning_management_project_04.jpg",
      "/assets/images/success-stories/aplusautism/learning_management_project_05.jpg",
      "/assets/images/success-stories/aplusautism/learning_management_project_06.jpg",
    ],
    credentials: [
      {
        link: "https://www.aplusautism.com/",
        username: "",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "/assets/pdf/AplusAutism.pdf" },
      {
        name: "Learning Management System (LMS)",
        url: "/assets/pdf/AplusAutism.pdf",
      },
    ],
    video: "/assets/videos/project-details/AplusAutism.mp4", // Can be a YouTube link as well
  },


  {
    id: 4,
    category: "mobile",
    image: "/assets/images/success-stories/product-3.jpg",
    link: "/project-details/4",
    title: "Microfinance",
    description: "Loan & Finance Management System",
    details:
      [
      "This microfinance loan management system is designed to help financial institutions efficiently manage loans, repayments, and customer financial data.The platform supports branches across multiple countries, ensuring seamless loan approvals, disbursements, collections, and compliance tracking.",
      "Agenda Of Microfinance Loan Management System:",
        [
          "1. Loan Management & Disbursement",
          "2. Customer & Compliance Management",
          "3. Performance & Insights",
          "4. Multi-Branch & Multi-Currency Support",
          "5. User Friendly Dashboard",
        ]
      ],
      technologies: {
        frontend: [
          "JavaScript",
          "Jquery",
          "Bootstrap",
          "HTML",
          "CSS",
          "Visual Studio Code"
        ],
        backend: [
          ".NET 6 Core",
          "SQL Server",
          "Entity Framework Core",
          "Swagger"
        ]
      },    
      thirdPartyTools: [
        "PayPal Payment Gateway",
        "GitHub",
        "JWT Token Authentication",
      ],
      images: [
        "/assets/images/success-stories/microfinance/microfinance_project_01.jpg",
        "/assets/images/success-stories/microfinance/microfinance_project_02.jpg",
        "/assets/images/success-stories/microfinance/microfinance_project_03.jpg",
        "/assets/images/success-stories/microfinance/microfinance_project_04.jpg",
        "/assets/images/success-stories/microfinance/microfinance_project_05.jpg",
        "/assets/images/success-stories/microfinance/microfinance_project_06.jpg",
      ],
      credentials: [
        {
          link: "https://preproduction.axcelsystems.com/",
          username: "",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "/assets/pdf/Microfinance.pdf" },
        {
          name: "Microfinance",
          url: "/assets/pdf/Microfinance.pdf",
        },
      ],
      video: "/assets/videos/project-details/Microfinance.mp4", 
  },

  {
    id: 5,
    category: "design",
    image: "/assets/images/success-stories/product-2.jpg",
    link: "/project-details/5",
    title: "XeroInvoiceAPI",
    description: "Rental Management System with Xero",
    details: [
      "Xero is a powerful cloud based accounting software platform designed to help small and medium sized businesses manage their finances efficiently. With features like invoicing, bank reconciliation, and financial reporting, Xero provides a comprehensive solution for businesses looking to streamline their accounting processes.",
    ],
    technologies: {
      frontend: [
        "JavaScript",
        "Jquery",
        "Bootstrap",
        "HTML",
        "CSS",
        "Visual Studio Code"
      ],
      backend: [
        ".NET 6 Core",
        "SQL Server",
        "Entity Framework Core",
        "Swagger UI",
        "ASP.NET Web API"
      ]
    },    
    thirdPartyTools: [
      "PayPal Payment Gateway",
      "GitHub",
      "JWT Token Authentication",
      "Azure DevOps",
      "Postman",
    ],
    images: [
      "/assets/images/success-stories/xeroInvoiceapi/xeroInvoiceapi_project_01.jpg",
      "/assets/images/success-stories/xeroInvoiceapi/xeroInvoiceapi_project_02.jpg",
      "/assets/images/success-stories/xeroInvoiceapi/xeroInvoiceapi_project_03.jpg",
      "/assets/images/success-stories/xeroInvoiceapi/xeroInvoiceapi_project_04.jpg",
      "/assets/images/success-stories/xeroInvoiceapi/xeroInvoiceapi_project_05.jpg",
      "/assets/images/success-stories/xeroInvoiceapi/xeroInvoiceapi_project_06.jpg",
    ],
    credentials: [
      {
        link: "https://xeroaccount.portfoliohubs.com",
        username: "",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "/assets/pdf/XeroInvoiceAPI.pdf" },
      {
        name: "XeroInvoiceAPI",
        url: "/assets/pdf/XeroInvoiceAPI.pdf",
      },
    ],
    video: "/assets/videos/project-details/XeroInvoiceAPI.mp4", 
  },

  {
    id: 6,
    category: "development",
    image: "/assets/images/success-stories/product-6.jpg",
    link: "/project-details/6",
    title: "Digital CRM",
    description: "Influencer Relationship Management",
    details: [
      "kleardigital was created with a vision to make it easier for everyone to organize their family and to do this in a trusted and safe way. That vision is now being delivered via a social networking platform through web and mobile applications, uniquely meeting the needs of parents, group administrators and children-oriented organizations.",
    ],
    technologies: {
      frontend: [
        "JavaScript",
        "Jquery",
        "Bootstrap",
        "HTML",
        "CSS",
        "ASP.net MVC 4.0",
        "SASS",
        "Angular JS "
      ],
      backend: [
        ".NET 6 Core",
        "Microsoft SQL Server 2012",
        "Entity Framework Core",
        "Swagger UI",
        "Entity framework 6.0"
      ]
    },    
    thirdPartyTools: [
      "PayPal Payment Gateway",
      "GitHub",
      "JWT Token Authentication",
      "Azure DevOps",
    ],
    images: [
      "/assets/images/success-stories/digital_crm/digitalCRM_project_01.jpg",
      "/assets/images/success-stories/digital_crm/digitalCRM_project_02.jpg",
      "/assets/images/success-stories/digital_crm/digitalCRM_project_03.jpg",
      "/assets/images/success-stories/digital_crm/digitalCRM_project_04.jpg",
      "/assets/images/success-stories/digital_crm/digitalCRM_project_05.jpg",
      "/assets/images/success-stories/digital_crm/digitalCRM_project_06.jpg",
    ],
    credentials: [
      {
        link: "https://kleardigitalteam.com",
        username: "cyrussuser",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "https://kleardigitalteam.com" },
      {
        name: "Digital CRM",
        url: "https://kleardigitalteam.com",
      },
    ],
    video: "https://kleardigitalteam.com", 
  },


  {
    id: 7,
    category: "development",
    image: "/assets/images/success-stories/product-7.jpg",
    link: "/project-details/7",
    title: "MacyCloud",
    description: "Precision Fabrication Software",
    details: [
        "A powerful CRM solution designed for influencers and brand management.",
      ],
      technologies: {
        frontend: [
          "JavaScript",
          "Jquery",
          "Bootstrap",
          "HTML",
          "CSS",
          "ASP.net MVC 4.0",
          "SASS",
          "Angular JS "
        ],
        backend: [
          ".NET 6 Core",
          "Microsoft SQL Server 2012",
          "Entity Framework Core",
          "Swagger UI",
          "Entity framework 6.0"
        ]
      },    
      thirdPartyTools: [
        "PayPal Payment Gateway",
        "GitHub",
        "JWT Token Authentication",
        "Azure DevOps",
      ],
      images: [
        "/assets/images/success-stories/macycloud/macycloud_project_01.jpg",
        "/assets/images/success-stories/macycloud/macycloud_project_02.jpg",
        "/assets/images/success-stories/macycloud/macycloud_project_03.jpg",
        "/assets/images/success-stories/macycloud/macycloud_project_04.jpg",
        "/assets/images/success-stories/macycloud/macycloud_project_05.jpg",
        "/assets/images/success-stories/macycloud/macycloud_project_06.jpg",
      ],
      credentials: [
        {
          link: "https://macycloud.approvedsheetmetal.com",
          username: "komal@gmail.com",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://macycloud.approvedsheetmetal.com" },
        {
          name: "MacyCloud",
          url: "https://macycloud.approvedsheetmetal.com/Identity/Account/Register?returnUrl=%2F",
        },
      ],
      video: "", 
  },
 
  {
    id: 8,
    category: "mobile",
    image: "/assets/images/success-stories/product-8.jpg",
    link: "/project-details/8",
    title: "PetCare",
    description: "Pet Care Reservation System",
    details: "A digital booking system for pet care and veterinary services.",
    technologies: {
      frontend: [
        "JavaScript",
        "Jquery",
        "Bootstrap",
        "HTML",
        "CSS",
        "Visual Studio Code"
      ],
      backend: [
        ".NET 6 Core",
        "SQL Server",
        "Entity Framework Core",
        "Swagger UI",
        "ASP.NET Web API"
      ]
    },    
    thirdPartyTools: [
      "PayPal Payment Gateway",
      "GitHub",
      "JWT Token Authentication",
      "Azure DevOps",
      "Postman",
    ],
    images: [
      "/assets/images/success-stories/petcare/petcare_project_01.jpg",
      "/assets/images/success-stories/petcare/petcare_project_02.jpg",
      "/assets/images/success-stories/petcare/petcare_project_03.jpg",
      "/assets/images/success-stories/petcare/petcare_project_04.jpg",
      "/assets/images/success-stories/petcare/petcare_project_05.jpg",
      "/assets/images/success-stories/petcare/petcare_project_06.jpg",
    ],
    credentials: [
      {
        link: "https://demo.petresortpro.com/Account/LogOn/?ReturnUrl=%2F",
        username: "",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "https://demo.petresortpro.com/Account/LogOn/?ReturnUrl=%2F" },
      {
        name: "PetCare",
        url: "https://demo.petresortpro.com/Account/LogOn/?ReturnUrl=%2F",
      },
    ],
    video: "", 
  },
  

  {
    id: 9,
    category: "react",
    image: "/assets/images/success-stories/product-9.jpg",
    link: "/project-details/9",
    title: "CERFAM - Knowledge Exchange Platform (KEPT)",
    description: "A dynamic platform enabling knowledge sharing, collaboration, and expert engagement in food security, nutrition, and sustainable development.",
    details: [
      "KEPT is an initiative under CERFAM and the UN World Food Programme (WFP) that facilitates knowledge exchange and best practice replication in rural development, food security, and agricultural value chains.",
      "Agenda Of Knowledge Exchange Platform (KEPT):",
      [
        "1. Knowledge Repository - Access research, case studies, and best practices.",
        "2. Experts Forum - Engage with global professionals on pressing challenges.",
        "3. Good Practices & Replication - Identify and implement successful interventions.",
        "4. Technical Training - Capacity-building workshops and courses.",
        "5. Data Collection & Mapping - Advanced analytics for evidence-based decisions.",
        "6. Multi-Stakeholder Engagement - Partnering with NGOs, governments, and private sector.",
        "7. Secure Authentication - Role-based access with JWT authentication.",
        "8. AI-Powered Insights - Smart recommendations and trend analysis."
      ]
    ],
    technologies: {
      frontend: [
        "React.js",
        "Next.js",
        "HTML",
        "CSS",
        "Bootstrap",
        "Visual Studio Code"
      ],
      backend: [
        "Node.js",
        "Express.js",
        "MongoDB",
        "GraphQL / REST API",
        "Swagger"
      ]
    },    
    thirdPartyTools: [
      "PayPal Payment Gateway",
      "GitHub",
      "JWT Token Authentication",
      "AWS Cloud Hosting",
      "Google Analytics"
    ],
    images: [
      "/assets/images/success-stories/kept/kept_project_01.jpg",
      "/assets/images/success-stories/kept/kept_project_02.jpg",
      "/assets/images/success-stories/kept/kept_project_03.jpg",
      "/assets/images/success-stories/kept/kept_project_04.jpg",
      "/assets/images/success-stories/kept/kept_project_05.jpg"
    ],
    credentials: [
      {
        "Website Link": "https://kept.coe.civ.wfp.org/expertsForum",
        "username": "",
        "password": ""
      }
    ],
    pdfs: [
      { "name": "Project Overview", "url": "https://kept.coe.civ.wfp.org/docs/overview.pdf" },
      {
        "name": "CERFAM",
        "url": "https://kept.coe.civ.wfp.org/docs/user-guide.pdf",
      }
    ],
    video: "", 
},

  {
    id: 10,
    category: "development",
    image: "/assets/images/success-stories/product-10.jpg",
    link: "/project-details/10",
    title: "Lifia",
    description: "Healthcare Research Collaboration",
    details: ["Lifia is a cutting edge healthcare technology platform designed to enhance program management, streamline data reporting, and support underserved communities. By leveraging advanced integrations and automation, Lifia helps healthcare organizations, including Ryan White programs, improve efficiency and data accuracy. Additionally, Lifia’s Research Network focuses on developing new healthcare models to address serious health disparities.",
      "Agenda Of Healthcare Research Collaboration:",
      [
        "1. Program Management - Monitor, report, and integrate key healthcare systems like Medicaid, eHARS, PBM, ADAP, and CAREWare.",
        "2. Client Support - A dedicated team to assist in program management and operations.",
        "3. Automated Reporting - Generate customized reports with powerful data visualization, including maps, graphs, and tables.",
        "4. Technical Training - Capacity building workshops and courses.",
        "5. Seamless Data Integration -  Automate data exchanges to reduce duplicate entries in EHR and CAREWare.",
        "6. GeoMapping & Analytics -  Identify trends, issues, and geographic impacts on targeted populations.",
        "7. Peer Support - Lifia.Me, an online community for individuals living with HIV/AIDS.",
        "8. Healthcare Research - Lifia Research Network studies innovative care delivery models for vulnerable populations."
        ]
    ],
    technologies: {
        frontend: [
            "React.js",
            "TypeScript",
            "Tailwind CSS",
            "HTML5",
            "CSS3",
            "Webpack"
        ],
        "backend": [
            "Node.js",
            "Express.js",
            "MongoDB",
            "GraphQL",
            "Firebase Authentication"
        ]
    },    
    thirdPartyTools: [
        "PayPal Payment Gateway",
        "GitHub",
        "JWT Token Authentication",
        "Azure DevOps",
        "Postman"
    ],
      images: [
        "/assets/images/success-stories/lifia/lifia_product_01.jpg",
        "/assets/images/success-stories/lifia/lifia_product_02.jpg",
        "/assets/images/success-stories/lifia/lifia_product_03.jpg",
        "/assets/images/success-stories/lifia/lifia_product_04.jpg",
        "/assets/images/success-stories/lifia/lifia_product_05.jpg",
        "/assets/images/success-stories/lifia/lifia_product_06.jpg",
      ],
      credentials: [
        {
          link: "https://www.lifia.org",
          username: "",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://www.lifia.org" },
        {
          name: "Lifia",
          url: "https://www.lifia.org",
        },
      ],
      video: "", 
  },


  {
    id: 11,
    category: "cms",
    image: "/assets/images/success-stories/product-11.jpg",
    link: "/project-details/11",
    title: "Viberent",
    description: "Rental Management & Online Booking Platform",
    details:
      "Viberent is a cloud-based rental management system designed to streamline rental business operations. With features like live inventory tracking, automated invoicing, seamless accounting integrations, and a powerful mobile app, Viberent helps rental businesses manage their workflow efficiently. From online bookings to equipment maintenance, Viberent empowers businesses to scale and succeed in the competitive rental industry.",
      technologies: {
        frontend: [
            "JavaScript",
            "JQuery",
            "Bootstrap",
            "HTML",
            "CSS",
            "TypeScript",
            "React.js",
            "Visual Studio Code"
        ],
        backend: [
            ".NET 6 Core",
            "SQL Server",
            "Entity Framework Core",
            "Swagger UI",
            "ASP.NET Web API",
            "Node.js",
            "GraphQL"
        ]
    },    
    thirdPartyTools: [
        "PayPal Payment Gateway",
        "GitHub",
        "JWT Token Authentication",
        "Azure DevOps",
        "Postman",
        "Stripe",
        "Zapier"
    ],
      images: [
        "/assets/images/success-stories/viberent/viberent_project_01.jpg",
        "/assets/images/success-stories/viberent/viberent_project_02.jpg",
        "/assets/images/success-stories/viberent/viberent_project_03.jpg",
        "/assets/images/success-stories/viberent/viberent_project_04.jpg",
        "/assets/images/success-stories/viberent/viberent_project_05.jpg",
        "/assets/images/success-stories/viberent/viberent_project_06.jpg",
      ],
      credentials: [
        {
          websiteLink: "https://viberenthq.com",
          username: "",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://viberenthq.com" },
        {
          name: "Viberent",
          url: "https://viberenthq.com",
        },
      ],
      video: "", 
  },

  {
    id: 12,
    category: "wordpress",
    image: "/assets/images/success-stories/product-12.jpg",
    link: "/project-details/12",
    title: "Lentorcentralresidences",
    description: "Lentor Central Residences",
    details:
      "Lentor Central Residences is a premium 99 year leasehold condominium development in District 26, designed for refined urban living. Developed by GuocoLand, Hong Leong Holdings, and CSC Land Group, this luxurious project features 456 well-designed units with modern finishes, exclusive amenities, and seamless connectivity. Future residents will benefit from top-tier facilities, lush landscapes, and proximity to reputable schools, shopping hubs, and nature parks. With smart home integration, elegant designs, and a prime location, Lentor Central Residences offers a perfect blend of comfort and convenience.",
      wordpress: {
            plugins: [
              "3D FlipBook : Dflip Lite",
                "Contact Form 7",
                "CTCore",
                "CTImport",
                "CTUsers",
                "Duplicate Page",
                "Floating Contact Button",
                "Gravity Forms",
                "PDF Embedder",
                "Popup Builder",
                "Responsive Accordion And Collapse",
                "Slider Revolution",
                "WPBakery Page Builder",
            ],
            themes: [
              "UnfinityPlus",
              "UnfinityPlus Child"
            ],
            thirdPartyPlugins: [
            "Font Awesome",
            "Akismet Anti-spam: Spam Protection",
            "Duplicator",
            "WP Mail SMTP",
            "Redux Framework",
            "PHP",
            "MySQL (Database Management)"
            ],
        },    

      images: [
        "/assets/images/success-stories/lentorcentralresidences/lentorcentralresidences_project_01.jpg",
        "/assets/images/success-stories/lentorcentralresidences/lentorcentralresidences_project_02.jpg",
        "/assets/images/success-stories/lentorcentralresidences/lentorcentralresidences_project_03.jpg",
        "/assets/images/success-stories/lentorcentralresidences/lentorcentralresidences_project_04.jpg",
        "/assets/images/success-stories/lentorcentralresidences/lentorcentralresidences_project_05.jpg",
        "/assets/images/success-stories/lentorcentralresidences/lentorcentralresidences_project_06.jpg",
      ],
      credentials: [
        {
          link: "https://www.lentorcentralresidences.showrooms.com.sg",
          username: "upwork",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://www.lentorcentralresidences.showrooms.com.sg" },
        {
          name: "Lentorcentralresidences",
          url: "https://www.lentorcentralresidences.showrooms.com.sg",
        },
      ],
      video: "", 
  },


  {
    id: 13,
    category: "wordpress",
    image: "/assets/images/success-stories/product-13.jpg",
    link: "/project-details/13",
    title: "W8CED",
    description: "Ward8 Community Economic",
    details:
      "The Ward 8 Community Economic Development Planning Process (W8CED) is a resident-driven initiative aimed at building wealth, promoting equity, and fostering economic growth in Ward 8, Washington, DC. Since 2020, thousands of residents, along with community, nonprofit, and business leaders, have collaborated to create a strategic plan that leverages local assets, prioritizes community well-being, and drives sustainable development. Through the Ward 8 Digital Collective, residents continue to advocate for positive change, ensuring long-term prosperity and accountability from stakeholders.",
      wordpress: {
         plugins: [
              "Elementor",
              "ElementsKit Lite",
            
            ],
            themes: [
              "Hello Elementor",
              "Hello Elementor Child"
            ],
            thirdPartyPlugins: [
            "PHP",
              "Essential Addons for Elementor Lite",
              "Header Footer Elementor",
              "MySQL (Database Management)"
            ],
        },    

      images: [
        "/assets/images/success-stories/w8ced/w8ced_project_01.jpg",
        "/assets/images/success-stories/w8ced/w8ced_project_02.jpg",
        "/assets/images/success-stories/w8ced/w8ced_project_03.jpg",
        "/assets/images/success-stories/w8ced/w8ced_project_04.jpg",
        "/assets/images/success-stories/w8ced/w8ced_project_05.jpg",
        "/assets/images/success-stories/w8ced/w8ced_project_06.jpg",
      ],
      credentials: [
        {
          link: "https://w8ced.org",
          username: "",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://w8ced.org" },
        {
          name: "W8CED",
          url: "https://w8ced.org",
        },
      ],
      video: "", 
  },


  {
    id: 14,
    category: "wordpress",
    image: "/assets/images/success-stories/product-14.jpg",
    link: "/project-details/14",
    title: "SEDSERVER",
    description: "Trusted legal document Service",
    details:
    [
      "SED SERVER, Inc. is a leading provider of legal support services, specializing in court filings, e-filing, skip tracing, investigative services, and compliance consulting for law firms, attorneys, and individuals. With over 20 years of experience, we offer real-time case tracking through our proprietary SEDSERVER Software, ensuring secure and efficient legal document processing.",
      "Our team of certified process servers and licensed private investigators delivers professional, reliable, and technology-driven solutions tailored to your legal and compliance needs."
    ],
    wordpress: {
            plugins: [
              "Elementor (Page Builder)",
              "Essential Addons for Elementor Lite",
              "ElementsKit Lite",
              "Header Footer Elementor",
              "LayerSlider",
              "Contact Form 7",
              "Js Compressor",
              "RevSlider",
              "WooCommerce",
            
            ],
            themes: [
              "Total"
            ],
            thirdPartyPlugins: [
            "SSL Encryption",
              "Secure Web Hosting",
              "PHP",
              "Cloudflare",
              "Google Analytics",
              "Google Search Console",
              "MySQL (Database Management)",
              "LiteSpeed Cache",
              "WP Rocket (Website Caching & Speed)"
            ],
        },    

    images: [
      "/assets/images/success-stories/sedserver/sedserver_project_01.jpg",
      "/assets/images/success-stories/sedserver/sedserver_project_02.jpg",
      "/assets/images/success-stories/sedserver/sedserver_project_03.jpg",
      "/assets/images/success-stories/sedserver/sedserver_project_04.jpg",
      "/assets/images/success-stories/sedserver/sedserver_project_05.jpg",
      "/assets/images/success-stories/sedserver/sedserver_project_06.jpg",
    ],
    credentials: [
      {
        link: "https://sedserver.com",
        username: "",
        password: ""
      }
    ],
    pdfs: [
      { name: "Project Overview", url: "https://sedserver.com" },
      {
        name: "SEDSERVER",
        url: "https://sedserver.com",
      },
    ],
    video: "", 
  },
 
  {
    id: 15,
    category: "react",
    image: "/assets/images/success-stories/product-15.jpg",
    link: "/project-details/15",
    title: "GotTickets",
    description: "Sell your event Tickets Online",
    details:[
      "GotTickets is a modern web application designed to simplify ticket sales and event management. It offers a smooth user experience for buyers and sellers, integrating secure payments and easy navigation.",
      "Agenda of GotTickets:",
      [
        "1. User Authentication (Login/Register)",
        "2. Event Listings & Filtering",
        "3. Secure Online Payments",
        "V4. enue & Category Management",
        "5. Mobile Responsive UI"
      ],
    ],
      technologies: {
        frontend: [
          "React.js",
          "Redux",
          "Bootstrap",
          "HTML5",
          "CSS3",
          "JavaScript",
          "Visual Studio Code",
          "Laravel"
        ],
        backend: [
          "Node.js",
          "Express.js",
          "MongoDB",
          "Mongoose",
          "JWT Authentication",
          "RESTful APIs"
        ]
      },    
      thirdPartyTools: [
        "Stripe Payment Gateway",
        "GitHub",
        "Firebase Authentication",
        "Cloudinary (Image Uploads)",
        "Postman (API Testing)"
      ],
      images: [
       "/assets/images/success-stories/gottickets/gottickets_project_01.jpg",
      "/assets/images/success-stories/gottickets/gottickets_project_02.jpg",
      "/assets/images/success-stories/gottickets/gottickets_project_03.jpg",
      "/assets/images/success-stories/gottickets/gottickets_project_04.jpg",
      "/assets/images/success-stories/gottickets/gottickets_project_05.jpg",
      "/assets/images/success-stories/gottickets/gottickets_project_06.jpg",
      ],
      credentials: [
        {
          link: "https://gottickets.online",
          username: "",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://gottickets.online" },
        {
          name: "GotTickets",
          url: "https://gottickets.online",
        },
      ],
      video: "", 
  },
  
  {
    id: 16,
    category: "react",
    image: "/assets/images/success-stories/product-16.jpg",
    link: "/project-details/16",
    title: "OnTopic",
    description: "Lets start talking with OnTopic",
    details:[
      "OnTopic makes it easier than ever to have meaningful conversations. Whether you’re chatting with friends, family, or new acquaintances, OnTopic helps break the ice and keep the conversation flowing.",
      "Agenda of OnTopic:",
      [
        "1. 1,000+ Thought Provoking Questions",
        "2. 20+ Unique Conversation Categories",
        "3. Fun & Engaging Discussion Starters",
        "4. Secure End to End Encrypted Chats",
        "5. Join or Start Chat Threads with Ease",
        "6. New Trending Topics Added Daily"
      ],
    ],
      technologies: {
        frontend: [
          "React.js",
          "Next.js",
          "Redux Toolkit",
          "TypeScript",
          "Bootstrap",
          "HTML",
          "CSS",
          "Material UI"
        ],
        backend: [
          "Node.js",
          "Express.js",
          "MongoDB",
          "Mongoose ORM",
          "JWT Authentication",
          "WebSockets",
          "Cloudinary (for media uploads)"
        ]
      },    
      thirdPartyTools: [
        "Firebase Authentication",
        "AWS S3",
        "Google Analytics",
        "Stripe Payment Gateway",
        "Postman for API Testing",
        "GitHub for Version Control",
        "CI/CD (GitHub Actions)"
      ],
      images: [
        "/assets/images/success-stories/ontopic/ontopic_project_01.jpg",
        "/assets/images/success-stories/ontopic/ontopic_project_02.jpg",
        "/assets/images/success-stories/ontopic/ontopic_project_03.jpg",
        "/assets/images/success-stories/ontopic/ontopic_project_04.jpg",
        "/assets/images/success-stories/ontopic/ontopic_project_05.jpg",
        "/assets/images/success-stories/ontopic/ontopic_project_06.jpg",
      ],
      credentials: [
        {
          link: "https://www.ontopic.app",
          username: "",
          password: ""
        }
      ],
      pdfs: [
        { name: "Project Overview", url: "https://www.ontopic.app" },
        {
          name: "OnTopic",
          url: "https://www.ontopic.app",
        },
      ],
      video: "", 
  },
];

function ProjectDetails({ showBreadcrumbs = true, showHeader = false }) {
  // const { id } = useParams();
  // const project = portfolioItems.find((item) => item.id === parseInt(id));

  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    AOS.init();
    // Convert id to number and find project
    const foundProject = portfolioItems.find(
      (item) => item.id === parseInt(id, 10)
    );
    setProject(foundProject);
  }, [id]); // Runs whenever the `id` changes
  

  if (!project) return;
  <section className="project-details py-4">
    <h2 className="text-center">Project Not Found</h2>
  </section>;
  

return (
  <>
    {showBreadcrumbs && (
      <Breadcrumbs
        pageTitle="Case Studies"
        pageSubtitle="Our commitment to quality exceeds expectations."
        activePage="Success Stories"
      />
    )}

    <section id="project-details" className="project-details">
      <div className="container">
        <div className="row">
          <div className="col-12">
          <h2 className="project-title text-danger" data-aos="fade-up">
              {project.title}
            </h2>

            {Array.isArray(project.details) ? (
              project.details.map((detail, index) => (
                Array.isArray(detail) ? (
                  // If detail is an array, map over it separately
                  <ul key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                    {detail.map((subDetail, subIndex) => (
                      <li key={subIndex} data-aos="fade-up" data-aos-delay={subIndex * 100}>
                        {subDetail}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                    {detail}
                  </p>
                )
              ))
            ) : (
              <p className="project-description" data-aos="fade-up">
                {project.details}
              </p>
            )}

          </div>
        </div>

        <div className="technologies pt-0 pb-3">
           {/* Project Images Slider */}
            <div className="row mt-3 mb-2">
                <div className="col-md-12 project-slider-block" data-aos="zoom-in">
                  {project.images?.length > 0 && (
                    <Swiper
                      modules={[Navigation, Autoplay]}
                      navigation
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      speed={800}
                      loop={true}
                      spaceBetween={20}
                      slidesPerView={1}
                      breakpoints={{
                        600: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                      className="project-slider"
                    >
                      {project.images.map((img, index) => (
                        <SwiperSlide key={index}>
                          <img
                            src={img}
                            alt={`Project ${project.title} ${index + 1}`}
                            className="project-image border img-fluid"
                            loading="lazy"
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                </div>
            </div>

          <div className="row mt-3 mb-3">
            {project.technologies?.frontend && (
              <div className="col-md-4" data-aos="fade-left" data-aos-delay="200">
                <div className="card border-0 rounded-0 shadow-sm">
                  <div className="card-header p-0">
                      <h5 className="mb-0 text-uppercase p-3 text-white bg-dark">🎨 Frontend Technologies</h5>
                  </div>
                  <div className="card-body">
                    <ul className="list-group list-group-flush">
                      {project.technologies.frontend.map((tech, index) => (
                        <li key={index} className="list-group-item">{tech}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {project.technologies?.backend && (
              <div className="col-md-4" data-aos="fade-up">
                <div className="card border-0 rounded-0 shadow-sm" data-aos-delay="300">
                  <div className="card-header p-0">
                      <h5 className="mb-0 text-uppercase p-3 text-white bg-dark">⚙️ Backend Technologies</h5>
                  </div>
                  <div className="card-body">
                  <ul className="list-group list-group-flush">
                    {project.technologies.backend.map((tech, index) => (
                      <li key={index} className="list-group-item">{tech}</li>
                    ))}
                  </ul>
                  </div>
                </div>
              </div>
            )}

            {project.thirdPartyTools?.length > 0 && (
            <div className="col-md-4" data-aos="fade-right">
                <div className="card border-0 rounded-0 shadow-sm" data-aos-delay="400">
                 <div className="card-header p-0">
                      <h5 className="mb-0 text-uppercase p-3 text-white bg-dark">🚀 Third Party Tools</h5>
                  </div>
                  <div className="card-body">
                  <ul className="list-group list-group-flush">
                    {project.thirdPartyTools.map((tool, index) => (
                      <li key={index} className="list-group-item">{tool}</li>
                    ))}
                  </ul>
                  </div>
                </div>
              </div>
            )}


                 {/* WordPress Plugins and Themes Logic */}
                {project.wordpress && (
                  <>
                    {project.wordpress.plugins?.length > 0 && (
                      <div className="col-md-4" data-aos="fade-up">
                        <div className="card border-0 rounded-0 shadow-sm" data-aos-delay="600">
                          <div className="card-header p-0">
                            <h5 className="mb-0 text-uppercase p-3 text-white bg-dark">🛠️ WordPress Plugins</h5>
                          </div>
                          <div className="card-body">
                            <ul className="list-group list-group-flush">
                              {project.wordpress.plugins.map((plugin, index) => (
                                <li key={index} className="list-group-item">{plugin}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {project.wordpress.themes?.length > 0 && (
                      <div className="col-md-4" data-aos="fade-down">
                        <div className="card border-0 rounded-0 shadow-sm" data-aos-delay="800">
                          <div className="card-header p-0">
                            <h5 className="mb-0 text-uppercase p-3 text-white bg-dark">🎨 WordPress Themes</h5>
                          </div>
                          <div className="card-body">
                            <ul className="list-group list-group-flush">
                              {project.wordpress.themes.map((theme, index) => (
                                <li key={index} className="list-group-item">{theme}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {project.wordpress.thirdPartyPlugins?.length > 0 && (
                      <div className="col-md-4" data-aos="fade-right">
                          <div className="card border-0 rounded-0 shadow-sm" data-aos-delay="400">
                            <div className="card-header p-0">
                                <h5 className="mb-0 text-uppercase p-3 text-white bg-dark">🚀 Third Party Plugins</h5>
                            </div>
                            <div className="card-body">
                            <ul className="list-group list-group-flush">
                              {project.wordpress.thirdPartyPlugins.map((tool, index) => (
                                <li key={index} className="list-group-item">{tool}</li>
                              ))}
                            </ul>
                            </div>
                          </div>
                        </div>
                      )}

                </>
                )}


          </div>

          <div className="row mt-5">
            <div className="col-md-6" data-aos="fade-right">
              <div className="card border-0 rounded-0 shadow-sm" style={{minHeight: '380px'}}>
                    <div className="card-header p-0">
                    <h5 className="mb-0 text-uppercase p-3">📄 Project Documents</h5>
                    </div>
                    <div className="card-body">
                        {project.pdfs && project.pdfs.length > 0 ? (
                          <ul className="list-unstyled">
                            {project.pdfs?.map((pdf, index) => (
                              <li key={index}>
                                <a href={pdf.url} target="_blank" rel="noopener noreferrer" className="btn btn-outline-success mb-2">
                                  📑 {pdf.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                          ) : (
                            <p className="m-0 p-3 bg-light">No document available for this project.</p>
                          )}
                          
                          {/* ✅ Project Credentials Section (Dynamic) */}
                            <div className="card border-0 rounded-0 shadow-sm mt-4">
                               <div className="card-header p-0 border-0">
                                  <h6 className="mb-0 bg-default border-bottom py-2 p-3">Project Credentials</h6>
                              </div>
                              <div className="card-body">
                                {project.credentials && project.credentials.length > 0 ? (
                                  <ul className="p-3">
                                    {project.credentials.map((cred, index) => (
                                      <li key={index}>
                                        <b>Website Link:</b> <a href={cred.link} target="_blank" rel="noopener noreferrer">{cred.link}</a>
                                        <br />
                                        <b>Username:</b> {cred.username} <br />
                                        <b>Password:</b> {cred.password}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p className="mb-1">No credentials available.</p>
                                )}
                              </div>
                            </div>
                    </div>
                  </div>
            </div>

            <div className="col-md-6" data-aos="fade-left">
            <div className="card border-0 rounded-0 shadow-sm">
                <div className="card-header p-0">
                 <h5 className="mb-0 text-uppercase p-3">🎥 Project Video</h5>
                </div>
                <div className="card-body">
                    {project.video ? (
                      project.video.includes("youtube.com") || project.video.includes("youtu.be") ? (
                        <iframe
                          width="100%"
                          height="315"
                          src={`${project.video}?autoplay=1&mute=1`} // Enable autoplay & mute for YouTube
                          title="Project Video"
                          className="rounded shadow"
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <video width="100%" controls autoPlay muted className="rounded shadow">
                          <source src={project.video} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )
                    ) : (
                      <p className="m-0 p-3 bg-light">No video available for this project.</p>
                    )}
                </div>
              </div>
              </div>

          </div>
        </div>

        <div className="col-12 text-end">
          <Link to="/success-stories" className="btn btn-primary">Back to Portfolio</Link>
        </div>
      </div>
    </section>
    <HappyClients />
    <Contact/>
  </>
);
}

export default ProjectDetails;